import React from 'react';
import { Button, Text } from '@chakra-ui/react';

export interface LanguageSelectorProps {
  currentLocale: string;
  onLocaleChange: (locale: string) => void;
  testID?: string;
}

const LOCALE_CYCLE = ['en', 'uk', 'de'] as const;
const LOCALE_LABELS: Record<string, string> = { en: 'EN', uk: 'UA', de: 'DE' };

export function LanguageSelector({
  currentLocale,
  onLocaleChange,
  testID,
}: LanguageSelectorProps) {
  const idx = Math.max(0, LOCALE_CYCLE.indexOf(currentLocale as (typeof LOCALE_CYCLE)[number]));
  const nextLocale = LOCALE_CYCLE[(idx + 1) % LOCALE_CYCLE.length];
  const label = LOCALE_LABELS[nextLocale];

  return (
    <Button
      onClick={() => onLocaleChange(nextLocale)}
      variant="ghost"
      h="32px"
      minW="48px"
      px={3}
      borderRadius="full"
      border="1px solid"
      borderColor="onboarding.plum"
      bg="transparent"
      _hover={{ bg: 'blackAlpha.50' }}
      data-testid={testID}
    >
      <Text fontSize="13px" fontWeight="600" color="onboarding.plum">
        {label}
      </Text>
    </Button>
  );
}

export default LanguageSelector;
